import React from "react";
import styled from "styled-components";
import Lightbulb from "./icons/Lightbulb";
import NotEqual from "./icons/NotEqual";
import Integration from "./icons/Integration";
import Result from "./icons/Result";

import { COLORS, DIALECTIC } from "../constants";

const StageIcon = ({ stage }) => {
	if (stage === DIALECTIC.CONCEPT) return <Lightbulb />;
	if (stage === DIALECTIC.NEGATION) return <NotEqual />;
	if (stage === DIALECTIC.SYNTHESIS) return <Integration />;
	return <Result />;
};

const StageNameContainer = styled.div`
	align-items: center;
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);
	display: flex;
	height: 32px;
	padding: 24px 0;
`;

const StageText = styled.span`
	align-items: center;
	color: rgba(255, 255, 255, 0.66);
	display: flex;
	font-size: 32px;
	height: 32px;
	line-height: 32px;
	margin: 0 0 0 8px;
	padding: 0;
`;

const getColor = (stage) => {
	if (stage === DIALECTIC.CONCEPT) return COLORS.PURPLE;
	if (stage === DIALECTIC.NEGATION) return COLORS.ORANGE;
	if (stage === DIALECTIC.SYNTHESIS) return COLORS.INDIGO;
	return COLORS.WHITE;
};

const StageName = ({ stage }) => {
	const color = getColor(stage);
	return (
		<StageNameContainer>
			<StageIcon stage={stage}  />
			<StageText color={color}>{stage.toUpperCase()}</StageText>
		</StageNameContainer>
	);
};

export default StageName;
